import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from '@material-ui/core/Icon';
import InputType from '../InputType';

//Components

const IconStyled = styled(Icon)`
  display: inline;
  vertical-align: middle;
  margin-right: 6px;
`;
const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 0 auto;
  font-size: 18px;
  font-weight: 500;
`

const ListCard = ({
  icon,
  text,
  children,
  ...other
}) => {
  return (
    <InputType {...other}>
      <TextContainer>
        {
          icon &&
          <IconStyled>{icon}</IconStyled>
        }
        {text}
      </TextContainer>
    </InputType>
  )
}

ListCard.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string,
};

ListCard.defaultProps = {
  type: null,
  icon: null,
};

export default ListCard;
